/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Event_AriaInputs */



/**
* | output |
* | --- |
* | "Fix all errors for this event" |
*
* @param {Qc_Fix_Event_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_event_aria = /** @type {((inputs?: Qc_Fix_Event_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Event_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger toutes les erreurs de cet événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Fehler dieses Events korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi tutti gli errori di questo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправить все ошибки этого события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir todos los errores de este evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复此事件的所有错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このイベントのすべてのエラーを修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस इवेंट की सभी त्रुटियाँ ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir todos os erros deste evento")
	return /** @type {LocalizedString} */ ("Fix all errors for this event")
});